export const state = () => ({
  nameErrors: null,
  endpointList: [],
  isSavingDataset: false
});
